module.exports = __webpack_public_path__ + "static/media/carrierRegistrantsData.d19b93eb.png";